import { IContact } from "./contact";

export interface IContactResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            contact: IContact,
            allTags: string[]
        }
    }
}